import { ReactNode } from 'react';

import { Button, Modal } from 'react-bootstrap';
import { useIntl } from 'react-intl';

import { WarningIcon } from 'assets/icons';

interface IDeleteConfirmationFooterProps {
  title: ReactNode;
  message: ReactNode;
  loading: boolean;
  onKeep: () => void;
  onConfirm: () => void;
}

export const DeleteConfirmationFooter = ({
  title,
  message,
  loading,
  onKeep,
  onConfirm
}: IDeleteConfirmationFooterProps) => {
  const intl = useIntl();

  return (
    <Modal.Footer
      className="bg-red-50 justify-content-between flex-nowrap"
      data-test="clinical-log-delete-confirmation"
    >
      <div className="d-flex align-items-start">
        <WarningIcon className="icon text-danger fs-4 me-3 mt-1" />
        <div>
          <div className="fw-bold" data-test="clinical-log-delete-title">
            {title}
          </div>
          <div data-test="clinical-log-delete-message">{message}</div>
        </div>
      </div>
      <div className="d-flex align-items-center flex-shrink-0 ms-3">
        <Button
          variant="link"
          onClick={onKeep}
          disabled={loading}
          data-test="clinical-log-delete-keep-btn"
        >
          {intl.formatMessage({ id: 'keepKey' })}
        </Button>
        <Button
          variant="danger"
          onClick={onConfirm}
          disabled={loading}
          data-test="clinical-log-delete-confirm-btn"
        >
          {intl.formatMessage({ id: 'deleteKey' })}
        </Button>
      </div>
    </Modal.Footer>
  );
};
